import React from 'react';
import { TestimonialSection as RawTestimonialSection } from '../../../components/landingPage/TestimonialSection';
import { SanityObject } from '../../../lib/landingPage';
import { MediaTestimonial, MediaTestimonialProps } from '../MediaTestimonial';
import { Wrapper } from '../Wrapper';

export type TestimonialSectionProps = {
    testimonials: SanityObject<MediaTestimonialProps>[];
};

export const TestimonialSection = Wrapper(
    (props: TestimonialSectionProps): JSX.Element => {
        return (
            <RawTestimonialSection>
                {props.testimonials.map(testimonial => (
                    <MediaTestimonial
                        key={testimonial._id}
                        value={testimonial}
                    />
                ))}
            </RawTestimonialSection>
        );
    },
    'testimonialSection'
);
